import {gql} from "@apollo/client";
import {REWARDMAPPING_ENTITY} from "../entities/rewardMappingEntity";

export const REWARDMAPPINGS_QUERY = gql`
    query rewardMappings {
      rewardMappings {...RewardMappingEntity}
    }
    ${REWARDMAPPING_ENTITY}
`;